import { Theme, Typography } from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    smavaProgressBar: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '8px'
    },
    smavaStepNumber: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center'
    },
    activeNumber: {
      backgroundColor: `${theme.palette.grey[600]} !important`
    },
    defaultNumber: {
      backgroundColor: theme.palette.grey[200],
      borderRadius: '50%',
      height: '40px',
      width: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    number: {
      color: theme.palette.common.white
    },
    active: {
      backgroundColor: `${theme.palette.primary[400]} !important`
    },
    defaultStep: {
      width: '100%',
      height: '10px',
      backgroundColor: theme.palette.primary[200],

      '&:last-child': {
        borderRadius: '0px 2px 2px 0px'
      },

      '&:first-child': {
        borderRadius: '2px 0px 0px 2px'
      }
    }
  })
)

const ProgressIndicatorSkeleton = () => {
  const {
    smavaProgressBar,
    active,
    defaultStep,
    smavaStepNumber,
    activeNumber,
    defaultNumber,
    number
  } = useStyles()

  return (
    <>
      <div className={smavaStepNumber}>
        {[...Array(5)].map((_, i) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={`step-index-${i}`}
            className={`${defaultNumber} ${i === 0 ? activeNumber : ''}`}
          >
            <Typography variant="h4" className={number}>
              {i + 1}
            </Typography>
          </div>
        ))}
      </div>
      <div className={smavaProgressBar}>
        {[...Array(5)].map((_, i) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={`step-index-${i}`}
            className={`${defaultStep} ${i === 0 ? active : ''}`}
          />
        ))}
      </div>
    </>
  )
}

export default ProgressIndicatorSkeleton
